import React from 'react';
import '../template-file-css/document-file-template.css';



export const HFI_BiopsychosocialEvaluation = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='HFI_BiopsychosocialEvaluation' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>Biopsychosocial Evaluation Age 0-5</h3></center></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Child Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtChildName' name='txtChildName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>DOB:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Age:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Gender:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='date' id='txtDateOfBirth' name='txtDateOfBirth' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtAge_1' name='txtAge_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male &nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Ethnic Background:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Relationship to Child:  </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtEthnicBackGround' name='txtEthnicBackGround' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtRelationshipChild' name='txtRelationshipChild' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Informant:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtInformant' name='txtInformant' className='add-only' /></td>

                    </tr>
                </table>



                <p className='w-750'>
                    <span className='eleHeader'>PRESENTING PROBLEM</span>
                    <span className='small'>(please include circumstances of onset (Onset-Frequency-Age-Intensity-Duration)</span>
                    <textarea id='txtPresentingProblem' name='txtPresentingProblem' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>CURRENT HEALTH STATUS</span>
                    <span className='small'>Where the child does received his/her health care? </span>
                    <textarea id='txtCurrentHealthStatus' name='txtCurrentHealthStatus' className='add-only'></textarea></p>

                <p className='w-750'>Approximate Date of last physical exam: <b>Month</b> &nbsp;
                    <input type='text' id='txtMonth' name='txtMonth' className='add-only w-150 custom-add-only' /> &nbsp; <b>Year:</b>
                    <input type='text' id='txtYear' name='txtYear' className='add-only w-150 custom-add-only' /></p>

                <p className='w-750'>
                    <span className='eleHeader'>Does child have any illnesses or conditions for which he or she receives or should receive regular care? (Describe below) </span>
                    <input type='radio' id='rbDoesChild_1' name='rbDoesChild' className='add-only' value='Asthma' /> Asthma
                    <input type='text' id='txtAsthma' name='txtAsthma' className='add-only' /> <br />

                    <input type='radio' id='rbDoesChild_2' name='rbDoesChild' className='add-only' value='Allergies' /> Allergies
                    <input type='text' id='txtAllergies' name='txtAllergies' className='add-only' /> <br />

                    <input type='radio' id='rbDoesChild_3' name='rbDoesChild' className='add-only' value='Diabetes' /> Diabetes
                    <input type='text' id='txtDiabetes' name='txtDiabetes' className='add-only' /> <br />

                    <input type='radio' id='rbDoesChild_4' name='rbDoesChild' className='add-only' value='Anemia' /> Anemia
                    <input type='text' id='txtAnemia' name='txtAnemia' className='add-only' /> <br />

                    <input type='radio' id='rbDoesChild_5' name='rbDoesChild' className='add-only' value='Seizures' /> Seizures
                    <input type='text' id='txtSeizures' name='txtSeizures' className='add-only' /> <br />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Any history of significant hospitalizations, surgical or invasive procedures: </span>
                    <textarea id='txtAnyHistorySignificant' name='txtAnyHistorySignificant' className='add-only'></textarea></p>

                <p className='w-750'><h4>MEDICAL HISTORY</h4></p>

                <p className='w-750'>
                    <span className='eleHeader'>Does the child take any medications:</span>
                    <input type='text' id='txtDoesThechildTake' name='txtDoesThechildTake' className='add-only' /> </p>

                <p className='w-750'>
                    <span className='eleHeader'>Name and Dose of Medication:</span>
                    <span className='small'> (e.g., Daily, As Needed)</span>
                    <input type='text' id='txtNameAndDose' name='txtNameAndDose' className='add-only' /> </p>

                <p className='w-750'>
                    <span className='eleHeader'>Name of Dose of Past Medications: </span>
                    <span className='small'>(include started and discontinued date)</span>
                    <input type='text' id='txtNameAndDosePast' name='txtNameAndDosePast' className='add-only' /> </p>

                <p className='w-750'><span className='eleHeader'>Sensitivities or Allergies to ANY Drugs?</span>
                    <input type='radio' id='rbSensitivities_Yes' name='rbSensitivities' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbSensitivities_No' name='rbSensitivities' className='add-only' value='No' /> No <br />
                    <b>Drug Name:</b>
                    <input type='text' id='txtDrugName' name='txtDrugName' className='add-only' /></p>

                <p className='w-750'>
                    <span className='eleHeader'>Reaction:</span>
                    <input type='text' id='txtReaction' name='txtReaction' className='add-only' />
                </p>

                <p className='w-750'><h4>DEVELOPMENTAL HISTORY</h4>
                </p>

                <p className='w-750'><span className='eleHeader'>Any complications during pregnancy, labor, and/or delivery?</span>
                    <input type='radio' id='rbAnyComplicationsDuring_Yes' name='rbAnyComplicationsDuring' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAnyComplicationsDuring_No' name='rbAnyComplicationsDuring' className='add-only' value='No' /> No <br />
                    <b>If yes, explain: </b>
                    <textarea id='txtIfYesExplain' name='txtIfYesExplain' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Major developmental stages met? </span>
                    <input type='radio' id='rbMajorDevelopmentalMet_Yes' name='rbMajorDevelopmentalMet' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbMajorDevelopmentalMet_No' name='rbMajorDevelopmentalMet' className='add-only' value='No' /> No <br />
                    <b>If no, explain:</b>
                    <textarea id='txtIfNoExplain' name='txtIfNoExplain' className='add-only'></textarea></p>

                <p className='w-750'><h4>DAYCARE/PRESCHOOL/SCHOOL</h4></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name of School</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Teacher</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtNameOfSchool' name='txtNameOfSchool' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtTeacher' name='txtTeacher' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Current or last Grade completed:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Any grades repeated:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Grade(s) Number:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCurrentOrlastGrade' name='txtCurrentOrlastGrade' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtAnyGradesRepeated' name='txtAnyGradesRepeated' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtGradeNumber' name='txtGradeNumber' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Special Education services including IEP:</span>
                    <input type='radio' id='rbSpecialEducationServicesIncluding_Yes' name='rbSpecialEducationServicesIncluding' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbSpecialEducationServicesIncluding_No' name='rbSpecialEducationServicesIncluding' className='add-only' value='No' /> No <br />
                    <b>If yes, specify services being provided: </b>
                    <textarea id='txtSpecifyServicesBeingProvided' name='txtSpecifyServicesBeingProvided' className='add-only'></textarea></p>


                <p className='w-750'>
                    <span className='eleHeader'>Please describe child's behavior in school. Include any suspensions and/or detentions? (this can be teacher and/or parent reports): </span>
                    <textarea id='txtPleaseDescribeChildBehavior' name='txtPleaseDescribeChildBehavior' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>Name of school counselor or social worker (if applicable): </span>
                    <input type='text' id='txtNameOfSchoolCounselor' name='txtNameOfSchoolCounselor' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Academic Performance: </span>
                    <input type='text' id='txtAcademicPerformance' name='txtAcademicPerformance' className='add-only' />
                </p>

                <p className='w-750'><h4>HISTORY OF PSYCHIATRIC AND BEHAVIORAL HEALTH SERVICES</h4></p>

                <table>
                    <tr>
                        <td className='w-50'>1. </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Age:</span> </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Dates of Treatment:</span></td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-350'>
                            <input type='text' id='txtAge' name='txtAge' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='date' id='txtDateOfTreatment' name='txtDateOfTreatment' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-350'>
                            <span className='eleHeader'>Symptoms/Condition:</span> </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Treatment Location:</span></td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-350'>
                            <input type='text' id='txtSymptomsCondition' name='txtSymptomsCondition' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtTreatmentLocation' name='txtTreatmentLocation' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-50'>2. </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Age:</span> </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Dates of Treatment:</span></td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-350'>
                            <input type='text' id='txtAge_1' name='txtAge_1' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='date' id='txtDateOfTreatment_1' name='txtDateOfTreatment_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-350'>
                            <span className='eleHeader'>Symptoms/Condition:</span> </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Treatment Location:</span></td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-350'>
                            <input type='text' id='txtSymptomsCondition_1' name='txtSymptomsCondition_1' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtTreatmentLocation_1' name='txtTreatmentLocation_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-50'>3. </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Age:</span> </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Dates of Treatment:</span></td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-350'>
                            <input type='text' id='txtAge_2' name='txtAge_2' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='date' id='txtDateOfTreatment_2' name='txtDateOfTreatment_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-350'>
                            <span className='eleHeader'>Symptoms/Condition:</span> </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Treatment Location:</span></td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-350'>
                            <input type='text' id='txtSymptomsCondition_2' name='txtSymptomsCondition_2' className='add-only' /></td>
                        <td className='w-350'>
                            <input type='text' id='txtTreatmentLocation_2' name='txtTreatmentLocation_2' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Age of first outpatient treatment: </span>
                    <input type='text' id='txtAgeOfFirstOutpatientTreatment' name='txtAgeOfFirstOutpatientTreatment' className='add-only' />
                </p>

                <p className='w-750'><span className='eleHeader'>Any psychiatric hospitalizations? </span>
                    <input type='radio' id='rbAnyPsychiatricHospitalizations_Yes' name='rbAnyPsychiatricHospitalizations' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAnyPsychiatricHospitalizations_No' name='rbAnyPsychiatricHospitalizations' className='add-only' value='No' /> No <br />
                    <b>If yes, age of first psychiatric hospitalization: </b>
                    <input type='text' id='txtPsychiatricHospitalization' name='txtPsychiatricHospitalization' className='add-only' /></p>

                <p className='w-750'><span className='eleHeader'>Medication prescribed for any condition? </span>
                    <input type='radio' id='rbMedicationPrescribedForAny_Yes' name='rbMedicationPrescribedForAny' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbMedicationPrescribedForAny_No' name='rbMedicationPrescribedForAny' className='add-only' value='No' /> No <br />
                    <b>If yes, Please explain:</b>
                    <input type='text' id='txtPsychiatricHospitalization' name='txtPsychiatricHospitalization' className='add-only' /></p>

                <p className='w-750'>
                    <span className='eleHeader'>DISCIPLINE/PARENTING </span>
                    <span className='small'> (please describe how you are have regularly disciplined your child and any needs you may have regarding parenting): </span>
                    <textarea id='txtDisciplineParenting' name='txtDisciplineParenting' className='add-only'></textarea></p>

                <p className='w-750'><h4>FAMILY/LIVING CONDITIONS</h4><br />
                    <b>Family home environment (who resides in home?)</b></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Relationship:</span></td>
                    </tr>
                    <tr>
                        1.<td className='w-370'>
                            <input type='text' id='txtName_1' name='txtName_1' className='add-only' /></td>
                        <td className='w-370'>
                            <input type='text' id='txtRelationship_1' name='txtRelationship_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        2.<td className='w-370'>
                            <input type='text' id='txtName_2' name='txtName_2' className='add-only' /></td>
                        <td className='w-370'>
                            <input type='text' id='txtRelationship_2' name='txtRelationship_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        3.<td className='w-370'>
                            <input type='text' id='txtName_3' name='txtName_3' className='add-only' /></td>
                        <td className='w-370'>
                            <input type='text' id='txtRelationship_3' name='txtRelationship_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        4.<td className='w-370'>
                            <input type='text' id='txtName_4' name='txtName_4' className='add-only' /></td>
                        <td className='w-370'>
                            <input type='text' id='txtRelationship_4' name='txtRelationship_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        5.<td className='w-370'>
                            <input type='text' id='txtName_5' name='txtName_5' className='add-only' /></td>
                        <td className='w-370'>
                            <input type='text' id='txtRelationship_5' name='txtRelationship_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        6.<td className='w-370'>
                            <input type='text' id='txtName_6' name='txtName_6' className='add-only' /></td>
                        <td className='w-370'>
                            <input type='text' id='txtRelationship_6' name='txtRelationship_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        7.<td className='w-370'>
                            <input type='text' id='txtName_7' name='txtName_7' className='add-only' /></td>
                        <td className='w-370'>
                            <input type='text' id='txtRelationship_7' name='txtRelationship_7' className='add-only' /></td>
                    </tr>
                    <tr>
                        8.<td className='w-370'>
                            <input type='text' id='txtName_8' name='txtName_8' className='add-only' /></td>
                        <td className='w-370'>
                            <input type='text' id='txtRelationship_8' name='txtRelationship_8' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Any recent changes in the home? </span>
                    <input type='text' id='txtAnyRecentChangesInHome' name='txtAnyRecentChangesInHome' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>SIGNIFICANT OTHERS INVOLVED </span>
                    <textarea id='txtSignificantOtherInvolved' name='txtSignificantOtherInvolved' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>SEXUAL HISTORY</span>
                    <span className='small'>(Please describe any known or observed sexual behavior child has displayed)</span>
                    <textarea id='txtSexualHistory' name='txtSexualHistory' className='add-only'></textarea></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>STREAM OF THOUGHT PERCENTION</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbStreamOfThought_Oriented' name='rbStreamOfThought' className='add-only' value='Oriented' /> Oriented to Reality</td>
                        <td className='w-250'>
                            <input type='radio' id='rbStreamOfThought_Auditory' name='rbStreamOfThought' className='add-only' value='Auditory' /> Auditory Hallucinations</td>
                        <td className='w-250'>
                            <input type='radio' id='rbStreamOfThought_Visual' name='rbStreamOfThought' className='add-only' value='Visual' /> Visual Hallucinations</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbStreamOfThought_Thought' name='rbStreamOfThought' className='add-only' value='Thought' /> Thought Flow Congruent</td>
                        <td className='w-250'>
                            <input type='radio' id='rbStreamOfThought_Associational' name='rbStreamOfThought' className='add-only' value='Associational' /> Associational Disturbance</td>
                        <td className='w-250'>
                            <input type='radio' id='rbStreamOfThought_Flow' name='rbStreamOfThought' className='add-only' value='Flow' /> Thought Flow Slowed</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbStreamOfThought_Accelerated' name='rbStreamOfThought' className='add-only' value='Thought' /> Thought Flow Accelerated</td>
                        <td className='w-250'>
                            <input type='radio' id='rbStreamOfThought_Suspicious' name='rbStreamOfThought' className='add-only' value='Suspicious' /> Suspicious</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <p className='w-750'><h4>SPIRITUAL, CULTURAL & ETHNIC BACKGROUND</h4></p>

                <p className='w-750'><span className='eleHeader'>Does child/family attend church? </span>
                    <input type='radio' id='rbDoesChildFamily_Yes' name='rbDoesChildFamily' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDoesChildFamily_No' name='rbDoesChildFamily' className='add-only' value='No' /> No <br />
                    <span className='eleHeader'>Are there any cultural or social issues that may impact treatment? </span>
                    <input type='text' id='txtAreThereAnyCulturalOrSocialIssues' name='txtAreThereAnyCulturalOrSocialIssues' className='add-only' /></p>

                <p className='w-750'><span className='eleHeader'>LEISURE ACTIVITIES/HOBBIES</span>
                    1.&nbsp;<input type='text' id='txtLeisureActivitiesHobbies' name='txtLeisureActivitiesHobbies' className='add-only w-700 custom-add-only' /><br />
                    2.&nbsp;<input type='text' id='txtLeisureActivitiesHobbies' name='txtLeisureActivitiesHobbies' className='add-only w-700 custom-add-only' /><br />
                    3.&nbsp;<input type='text' id='txtLeisureActivitiesHobbies' name='txtLeisureActivitiesHobbies' className='add-only w-700 custom-add-only' /></p>

                <p className='w-750'><h4>LIST FIRST NAMES, RELATIONSHIP & AGES OF SIBLINGS</h4></p>

                <table>
                    <tr>
                        <td className='w-240'>
                            <span className='eleHeader'>Name:</span></td>
                        <td className='w-240'>
                            <span className='eleHeader'>Relationship:</span></td>
                        <td className='w-240'>
                            <span className='eleHeader'>Age:</span></td>
                    </tr>
                    <tr>
                        1.<td className='w-240'>
                            <input type='text' id='txtName_9' name='txtName_9' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtRelationship_9' name='txtRelationship_9' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtAge_9' name='txtAge_9' className='add-only' /></td>
                    </tr>
                    <tr>
                        2.<td className='w-240'>
                            <input type='text' id='txtName_10' name='txtName_10' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtRelationship_10' name='txtRelationship_10' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtAge_10' name='txtAge_10' className='add-only' /></td>
                    </tr>
                    <tr>
                        3.<td className='w-240'>
                            <input type='text' id='txtName_11' name='txtName_11' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtRelationship_11' name='txtRelationship_11' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtAge_11' name='txtAge_11' className='add-only' /></td>
                    </tr>
                    <tr>
                        4.<td className='w-240'>
                            <input type='text' id='txtName_12' name='txtName_12' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtRelationship_12' name='txtRelationship_12' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtAge_12' name='txtAge_12' className='add-only' /></td>
                    </tr>
                    <tr>
                        5.<td className='w-240'>
                            <input type='text' id='txtName_13' name='txtName_13' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtRelationship_13' name='txtRelationship_13' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtAge_13' name='txtAge_13' className='add-only' /></td>
                    </tr>
                    <tr>
                        6.<td className='w-240'>
                            <input type='text' id='txtName_14' name='txtName_14' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtRelationship_14' name='txtRelationship_14' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtAge_14' name='txtAge_14' className='add-only' /></td>
                    </tr>

                </table>

                <p className='w-750'>
                    <span className='eleHeader'>If the child is not living with biological parent(s), obtain information about whereabouts of non-resident parent, visitation, divorce history, out-of home placements etc.</span>
                    <textarea id='txtIfTheChildNotLivingWithBiologicalParent' name='txtIfTheChildNotLivingWithBiologicalParent' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Is there anyone who is more familiar with this child's history than interviewee? </span>
                    <input type='radio' id='rbIsThereAnyoneWhoIsMoreFamiliar_Yes' name='rbIsThereAnyoneWhoIsMoreFamiliar' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbIsThereAnyoneWhoIsMoreFamiliar_No' name='rbIsThereAnyoneWhoIsMoreFamiliar' className='add-only' value='No' /> No <br />
                </p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Relationship:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone Number:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName_15' name='txtName_15' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtRelationShip_15' name='txtRelationShip_15' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtPhoneNumber' name='txtPhoneNumber' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><h4>CURRENT MENTAL STATUS EXAM</h4></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>APPERANCE</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbApperance_1' name='rbApperance' className='add-only' value='1' /> well groomed</td>
                        <td className='w-250'>
                            <input type='radio' id='rbApperance_2' name='rbApperance' className='add-only' value='2' /> physically unkempt/unclean</td>
                        <td className='w-250'>
                            <input type='radio' id='rbApperance_3' name='rbApperance' className='add-only' value='3' /> clothing disheveled</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbApperance_4' name='rbApperance' className='add-only' value='4' /> clothing unusual/bizarre</td>
                        <td className='w-250'>
                            <input type='radio' id='rbApperance_5' name='rbApperance' className='add-only' value='5' /> unusual physical features</td>
                        <td className='w-250'>
                            &nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>MOTOR STATUS</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbMotorStatus_1' name='rbMotorStatus' className='add-only' value='1' /> good posture</td>
                        <td className='w-187'>
                            <input type='radio' id='rbMotorStatus_2' name='rbMotorStatus' className='add-only' value='2' /> relaxed posture</td>
                        <td className='w-187'>
                            <input type='radio' id='rbMotorStatus_3' name='rbMotorStatus' className='add-only' value='3' /> slumped</td>
                        <td className='w-187'>
                            <input type='radio' id='rbMotorStatus_4' name='rbMotorStatus' className='add-only' value='4' /> stupor</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbMotorStatus_5' name='rbMotorStatus' className='add-only' value='5' /> rigid/tense</td>
                        <td className='w-187'>
                            <input type='radio' id='rbMotorStatus_6' name='rbMotorStatus' className='add-only' value='6' /> atypical/inappropriate</td>
                        <td className='w-187'>
                            <input type='radio' id='rbMotorStatus_7' name='rbMotorStatus' className='add-only' value='7' /> physically challenged</td>
                        <td className='w-187'>
                            <input type='radio' id='rbMotorStatus_8' name='rbMotorStatus' className='add-only' value='8' /> unusual/bizarre gait</td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbMotorStatus_9' name='rbMotorStatus' className='add-only' value='9' /> unusual mannerisms</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>SPEECH</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbSpeech_1' name='rbSpeech' className='add-only' value='1' /> normal volume - speed</td>
                        <td className='w-187'>
                            <input type='radio' id='rbSpeech_2' name='rbSpeech' className='add-only' value='2' /> too loud - soft</td>
                        <td className='w-187'>
                            <input type='radio' id='rbSpeech_3' name='rbSpeech' className='add-only' value='3' /> too fast - slow</td>
                        <td className='w-187'>
                            <input type='radio' id='rbSpeech_4' name='rbSpeech' className='add-only' value='4' /> difficulty with English</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbSpeech_5' name='rbSpeech' className='add-only' value='5' /> overly talkative</td>
                        <td className='w-187'>
                            <input type='radio' id='rbSpeech_6' name='rbSpeech' className='add-only' value='6' /> unresponsive</td>
                        <td className='w-187'>
                            <input type='radio' id='rbSpeech_7' name='rbSpeech' className='add-only' value='7' /> loose associations</td>
                        <td className='w-187'>
                            <input type='radio' id='rbSpeech_8' name='rbSpeech' className='add-only' value='8' /> flight of ideas</td>

                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbSpeech_9' name='rbSpeech' className='add-only' value='9' /> slurred</td>
                        <td className='w-187'>
                            <input type='radio' id='rbSpeech_10' name='rbSpeech' className='add-only' value='10' /> incoherent</td>
                        <td className='w-187'>
                            &nbsp;</td>
                        <td className='w-187'>
                            &nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>MOOD</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbMood_1' name='rbMood' className='add-only' value='1' /> appropriate to circumstance</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMood_2' name='rbMood' className='add-only' value='2' /> euphoric/elated</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMood_3' name='rbMood' className='add-only' value='3' /> sad/depressed</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbMood_4' name='rbMood' className='add-only' value='4' /> angry/hostile</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMood_5' name='rbMood' className='add-only' value='5' /> fearful/apprehensive</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMood_6' name='rbMood' className='add-only' value='6' /> anxious</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>FACIAL EXPRESSION</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbFacialExpession_1' name='rbFacialExpession' className='add-only' value='1' /> calm</td>
                        <td className='w-187'>
                            <input type='radio' id='rbFacialExpession_2' name='rbFacialExpession' className='add-only' value='2' /> alert</td>
                        <td className='w-187'>
                            <input type='radio' id='rbFacialExpession_3' name='rbFacialExpession' className='add-only' value='3' /> anxiety/fear</td>
                        <td className='w-187'>
                            <input type='radio' id='rbFacialExpession_4' name='rbFacialExpession' className='add-only' value='4' /> flat</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbFacialExpession_5' name='rbFacialExpession' className='add-only' value='5' /> smiling</td>
                        <td className='w-187'>
                            <input type='radio' id='rbFacialExpession_6' name='rbFacialExpession' className='add-only' value='6' /> inappropriate / bizarre</td>
                        <td className='w-187'>
                            <input type='radio' id='rbFacialExpession_7' name='rbFacialExpession' className='add-only' value='7' /> tic</td>
                        <td className='w-187'>
                            <input type='radio' id='rbFacialExpession_8' name='rbFacialExpession' className='add-only' value='8' /> distant gaze </td>

                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>BEHAVIOR/EMOTIONAL STATE</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_1' name='rbBehaviorEmotionalState' className='add-only' value='1' /> appropriate to circumstance</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_2' name='rbBehaviorEmotionalState' className='add-only' value='2' /> inappropriate</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_3' name='rbBehaviorEmotionalState' className='add-only' value='3' /> cooperative</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_4' name='rbBehaviorEmotionalState' className='add-only' value='4' /> uncooperative</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_5' name='rbBehaviorEmotionalState' className='add-only' value='5' /> agitated</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_6' name='rbBehaviorEmotionalState' className='add-only' value='6' /> hostile</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_7' name='rbBehaviorEmotionalState' className='add-only' value='7' /> aggressive/violent</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_8' name='rbBehaviorEmotionalState' className='add-only' value='8' /> elated</td>

                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_9' name='rbBehaviorEmotionalState' className='add-only' value='9' /> demanding</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_10' name='rbBehaviorEmotionalState' className='add-only' value='10' /> attention seeking</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_11' name='rbBehaviorEmotionalState' className='add-only' value='11' /> suspicious</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_12' name='rbBehaviorEmotionalState' className='add-only' value='12' /> anxious</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_13' name='rbBehaviorEmotionalState' className='add-only' value='13' /> defensive</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_14' name='rbBehaviorEmotionalState' className='add-only' value='14' /> unpredictable reaction</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_15' name='rbBehaviorEmotionalState' className='add-only' value='15' /> anti-social</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_16' name='rbBehaviorEmotionalState' className='add-only' value='16' /> manipulative</td>

                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_17' name='rbBehaviorEmotionalState' className='add-only' value='17' /> disoriented</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_18' name='rbBehaviorEmotionalState' className='add-only' value='18' /> regressed</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_19' name='rbBehaviorEmotionalState' className='add-only' value='19' /> withdrawn</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_20' name='rbBehaviorEmotionalState' className='add-only' value='20' /> confused</td>

                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_21' name='rbBehaviorEmotionalState' className='add-only' value='21' /> lethargic</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_22' name='rbBehaviorEmotionalState' className='add-only' value='22' /> passive</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_23' name='rbBehaviorEmotionalState' className='add-only' value='23' /> sensual/sexual</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBehaviorEmotionalState_24' name='rbBehaviorEmotionalState' className='add-only' value='24' /> overly pleasing</td>

                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>CONTENT OF THOUGHT</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_1' name='rbContentOfThought' className='add-only' value='1' /> appropriate</td>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_2' name='rbContentOfThought' className='add-only' value='2' /> delusions</td>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_3' name='rbContentOfThought' className='add-only' value='3' /> concrete thinking</td>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_4' name='rbContentOfThought' className='add-only' value='4' /> obsessive</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_5' name='rbContentOfThought' className='add-only' value='5' /> compulsive</td>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_6' name='rbContentOfThought' className='add-only' value='6' /> ideas of reference</td>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_7' name='rbContentOfThought' className='add-only' value='7' /> ideas of persecution</td>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_8' name='rbContentOfThought' className='add-only' value='8' /> ambivalent</td>

                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_9' name='rbContentOfThought' className='add-only' value='9' /> phobic</td>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_10' name='rbContentOfThought' className='add-only' value='10' /> suicidal ideation</td>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_11' name='rbContentOfThought' className='add-only' value='11' /> homicidal ideation</td>
                        <td className='w-187'>
                            &nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>MEMORY</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbMemory_1' name='rbMemory' className='add-only' value='1' /> recall appears intact</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMemory_2' name='rbMemory' className='add-only' value='2' /> impaired immediate recall</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMemory_3' name='rbMemory' className='add-only' value='3' /> impaired recent memory</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbMemory_4' name='rbMemory' className='add-only' value='4' /> impaired remote memory</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMemory_5' name='rbMemory' className='add-only' value='5' /> oriented to person, place, time</td>
                        <td className='w-250'>
                            &nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>INSIGHT AND JUDGMENT</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbInsightAndJudgment_1' name='rbInsightAndJudgment' className='add-only' value='1' /> open/aware of circumstances </td>
                        <td className='w-250'>
                            <input type='radio' id='rbInsightAndJudgment_2' name='rbInsightAndJudgment' className='add-only' value='2' /> difficulty acknowledging problems</td>
                        <td className='w-250'>
                            <input type='radio' id='rbInsightAndJudgment_3' name='rbInsightAndJudgment' className='add-only' value='3' /> blames others</td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbInsightAndJudgment_4' name='rbInsightAndJudgment' className='add-only' value='4' /> blames circumstances</td>
                        <td className='w-250'>
                            <input type='radio' id='rbInsightAndJudgment_5' name='rbInsightAndJudgment' className='add-only' value='5' /> managing life situations</td>
                        <td className='w-250'>
                            <input type='radio' id='rbInsightAndJudgment_6' name='rbInsightAndJudgment' className='add-only' value='6' /> avoiding life situations</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbInsightAndJudgment_7' name='rbInsightAndJudgment' className='add-only' value='7' /> impaired ability to manage daily living</td>
                        <td className='w-250'>
                            <input type='radio' id='rbInsightAndJudgment_8' name='rbInsightAndJudgment' className='add-only' value='8' /> impaired ability to make reasonable life decision</td>
                        <td className='w-250'>
                            &nbsp;</td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>RELATIONSHIP TO EVALUATOR</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbRelationshipToEvaluator_1' name='rbRelationshipToEvaluator' className='add-only' value='1' /> cooperative</td>
                        <td className='w-187'>
                            <input type='radio' id='rbRelationshipToEvaluator_2' name='rbRelationshipToEvaluator' className='add-only' value='2' /> uncooperative</td>
                        <td className='w-187'>
                            <input type='radio' id='rbRelationshipToEvaluator_3' name='rbRelationshipToEvaluator' className='add-only' value='3' /> aggressive</td>
                        <td className='w-187'>
                            <input type='radio' id='rbRelationshipToEvaluator_4' name='rbRelationshipToEvaluator' className='add-only' value='4' /> submissive</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbRelationshipToEvaluator_5' name='rbRelationshipToEvaluator' className='add-only' value='5' /> provocative</td>
                        <td className='w-187'>
                            &nbsp;</td>
                        <td className='w-187'>
                            &nbsp;</td>
                        <td className='w-187'>
                            &nbsp;</td>

                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Has your child experienced any of the following?</span>
                    <span className='small'>(Please indicated if within the last 30 days)</span>
                    <input type='checkbox' id='cbHasYourChildExperienced_1' name='cbHasYourChildExperienced-1' className='add-only' value='Poor' /> Poor Appetite or  &nbsp;
                    <input type='checkbox' id='cbHasYourChildExperienced_2' name='cbHasYourChildExperienced_2' className='add-only' value='Overeating' /> Overeating  <br />

                    <input type='checkbox' id='cbHasYourChildExperienced_3' name='cbHasYourChildExperienced_3' className='add-only' value='Concentration' /> Poor Concentration or &nbsp;
                    <input type='checkbox' id='cbHasYourChildExperienced-4' name='cbHasYourChildExperienced-4' className='add-only' value='Difficulty' /> Difficulty Making Decisions  <br />

                    <input type='checkbox' id='cbHasYourChildExperienced-5' name='cbHasYourChildExperienced-5' className='add-only' value='Problems' /> Problems with sleep (please describe):
                    <input type='text' id='txtHasYourChild' name='txtHasYourChild' className='add-only' /> <br />

                    <input type='checkbox' id='cbHasYourChildExperienced-6' name='cbHasYourChildExperienced-6' className='add-only' value='Low' /> Low Energy or  &nbsp;
                    <input type='checkbox' id='cbHasYourChildExperienced_7' name='cbHasYourChildExperienced_7' className='add-only' value='Fatigue' /> Fatigue <br />

                    <input type='checkbox' id='cbHasYourChildExperienced_8' name='cbHasYourChildExperienced_8' className='add-only' value='Feelings' /> Feelings of Hopelessness<br />
                    <input type='checkbox' id='cbHasYourChildExperienced_9' name='cbHasYourChildExperienced_9' className='add-only' value='LowSelfEsteem' /> Low Self-Esteem<br />
                </p>

                <p className='w-750'><span className='eleHeader'>Worry/Anxiety? </span>
                    <span className='small'>(Has he/she ever experienced serious anxiety/tension-seeming "uptight", unreasonable worry, and/or inability to feel relaxed?) </span>
                    <textarea id='txtWorryAnxiety' name='txtWorryAnxiety' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Fear/Paranoid? </span>
                    <span className='small'>(Has he/she ever felt scared or paranoid that something/someone was going to hurt them or family?): </span>
                    <textarea id='txtFearParanoid' name='txtFearParanoid' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Anger?</span>
                    <span className='small'>(Has he/she ever experienced trouble controlling violent behavior indicating episodes of rage, difficulty calming themselves down, and/or seems to have a low frustration tolerance?):</span>
                    <textarea id='txtAnger' name='txtAnger' className='add-only'></textarea></p>

                <p className='w-750'><h4>DFCS INVOVLEMENT</h4></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name of Case Manager: </span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone Number: </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtNameOfCaseManager' name='txtNameOfCaseManager' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPhoneNumber_1' name='txtPhoneNumber_1' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>DID CHILD TEST POSITIVE FOR ANY SUBSTANCE WHEN BORN? (PLEASE LIST)</span>
                    <textarea id='txtDidChildTestPositive' name='txtDidChildTestPositive' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>ANY HISTORY OF PHYSICAL/SEXUAL/EMOTIONAL ABUSE </span>
                    <span className='small'>(Please include history of DFCS involvement and the most severe incident)</span>
                    <textarea id='txtAnyHistoryOfPhysical' name='txtAnyHistoryOfPhysical' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>ANY HISTORY OF SUICIDAL/HOMICIDAL THOUGHTS OR ACTIONS? </span>
                    <span className='small'>(Please include present/past attempts and/or harmful behaviors to self/others)</span>
                    <textarea id='txtAnyHistory' name='txtAnyHistory' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>EMOTIONAL STATUS</h4></p>

                <p className='w-750'><span className='eleHeader'>Current mood?</span>
                    <span className='small'>(At the time of the interview in child's or parent's words)</span>
                    <textarea id='txtCurrentMood' name='txtCurrentMood' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Mood majority of the time? </span>
                    <textarea id='txtMoodMajorityOfThe' name='txtMoodMajorityOfThe' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>(Has your child ever had a significant period in which he/she has experienced the following symptoms?)
                    <b>Mood Wings/Mania?</b>(Has he/she ever experienced any mania symptoms? Pleas describe to the best of your knowledge) </span>
                    <textarea id='txtHasYourChildEverHadSignificant' name='txtHasYourChildEverHadSignificant' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Sad/Depressed?</span>
                    <span className='small'>(Has he/she ever had significant depression causing difficulty in daily functioning? Pleas describe to the best of your knowledge): </span>
                    <textarea id='txtSadDepressed' name='txtSadDepressed' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>HISTORY OF SUBSTANCE USE/ABUSE</h4></p>

                <p className='w-750'><span className='eleHeader'>Has your child ever been exposed to/experimented/abused any alcohol or other drugs? </span>
                    <input type='radio' id='rbHasYourChildEverBeenExposedToDrugs_Yes' name='rbHasYourChildEverBeenExposedToDrugs' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHasYourChildEverBeenExposedToDrugs_No' name='rbHasYourChildEverBeenExposedToDrugs' className='add-only' value='No' /> No  <br />
                    <b>(If the answer is yes, please continue/complete the following)</b></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Drug</span></td>
                        <td className='w-100'>
                            <span className='eleHeader'>Age Began</span></td>
                        <td className='w-100'>
                            <span className='eleHeader'>Type</span></td>
                        <td className='w-100'>
                            <span className='eleHeader'>Frequency</span></td>
                        <td className='w-100'>
                            <span className='eleHeader'>Amount</span></td>
                        <td className='w-100'>
                            <span className='eleHeader'>Last Use</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Alcohol</td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeBegan_1' name='txtAgeBegan_1' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtType_1' name='txtType_1' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtAmount_1' name='txtAmount_1' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtLastUse_1' name='txtLastUse_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Amphetamines (Speed, Ritalin)</td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeBegan_2' name='txtAgeBegan_2' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtType_2' name='txtType_2' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtAmount_2' name='txtAmount_2' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtLastUse_2' name='txtLastUse_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Barbiturates Sedatives (Somas)</td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeBegan_3' name='txtAgeBegan_3' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtType_3' name='txtType_3' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtAmount_3' name='txtAmount_3' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtLastUse_3' name='txtLastUse_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>CNS/De pressants/Tranquilizers (Valium, Xanax)</td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeBegan_4' name='txtAgeBegan_4' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtType_4' name='txtType_4' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtFrequency_4' name='txtFrequency_4' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtAmount_4' name='txtAmount_4' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtLastUse_4' name='txtLastUse_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Marijuana/Hashish</td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeBegan_5' name='txtAgeBegan_5' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtType_5' name='txtType_5' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtFrequency_5' name='txtFrequency_5' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtAmount_5' name='txtAmount_5' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtLastUse_5' name='txtLastUse_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Narcotics/Opiates Heroin, Methadone, Morphine, Codeine, OxyContin</td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeBegan_6' name='txtAgeBegan_6' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtType_6' name='txtType_6' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtFrequency_6' name='txtFrequency_6' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtAmount_6' name='txtAmount_6' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtLastUse_6' name='txtLastUse_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Hallucinogen/LSD .DMT (Mushrooms, Acid, Ecstasy)</td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeBegan_7' name='txtAgeBegan_7' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtType_7' name='txtType_7' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtFrequency_7' name='txtFrequency_7' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtAmount_7' name='txtAmount_7' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtLastUse_7' name='txtLastUse_7' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Cocaine/Crack</td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeBegan_8' name='txtAgeBegan_8' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtType_8' name='txtType_8' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtFrequency_8' name='txtFrequency_8' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtAmount_8' name='txtAmount_8' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtLastUse_8' name='txtLastUse_8' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Inhalants (Whipits, Expo, Freon)</td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeBegan_9' name='txtAgeBegan_9' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtType_9' name='txtType_9' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtFrequency_9' name='txtFrequency_9' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtAmount_9' name='txtAmount_9' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtLastUse_9' name='txtLastUse_9' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Synthetics</td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeBegan_10' name='txtAgeBegan_10' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtType_10' name='txtType_10' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtFrequency_10' name='txtFrequency_10' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtAmount_10' name='txtAmount_10' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtLastUse_10' name='txtLastUse_10' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Other/Tobacco (Cigarettes, Vapes)</td>
                        <td className='w-100'>
                            <input type='text' id='txtAgeBegan_11' name='txtAgeBegan_11' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtType_11' name='txtType_11' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtFrequency_11' name='txtFrequency_11' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtAmount_11' name='txtAmount_11' className='add-only' /></td>
                        <td className='w-100'>
                            <input type='text' id='txtLastUse_11' name='txtLastUse_11' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><h4>FAMILY HISTORY</h4>(Medical, Mental Health, Substance Abuse)</p>

                <table>
                    <tr>
                        <td className='w-240'>
                            <span className='eleHeader'>Relationship:</span></td>
                        <td className='w-240'>
                            <span className='eleHeader'>Disorder:</span></td>
                        <td className='w-240'>
                            <span className='eleHeader'>Specific:</span></td>
                    </tr>
                    <tr>
                        1.<td className='w-240'>
                            <input type='text' id='txtRelationship_15' name='txtRelationship_15' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtDisorder_1' name='txtDisorder_1' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtSpecific_1' name='txtSpecific_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        2.<td className='w-240'>
                            <input type='text' id='txtRelationship_16' name='txtRelationship_16' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtDisorder_2' name='txtDisorder_2' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtSpecific_2' name='txtSpecific_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        3.<td className='w-240'>
                            <input type='text' id='txtRelationship_17' name='txtRelationship_17' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtDisorder_3' name='txtDisorder_3' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtSpecific_3' name='txtSpecific_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        4.<td className='w-240'>
                            <input type='text' id='txtRelationship_18' name='txtRelationship_18' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtDisorder_4' name='txtDisorder_4' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtSpecific_4' name='txtSpecific_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        5.<td className='w-240'>
                            <input type='text' id='txtRelationship_19' name='txtRelationship_19' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtDisorder_5' name='txtDisorder_5' className='add-only' /></td>
                        <td className='w-240'>
                            <input type='text' id='txtSpecific_5' name='txtSpecific_5' className='add-only' /></td>
                    </tr>


                </table>
                <p className='w-750'><h4>LEGAL HISTORY</h4></p>

                <p className='w-750'><span className='eleHeader'>Has child ever been arrested?</span>
                    <input type='radio' id='rbHasYourChildEverBeenArrested_Yes' name='rbHasYourChildEverBeenArrested' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHasYourChildEverBeenArrested_No' name='rbHasYourChildEverBeenArrested' className='add-only' value='No' /> No  <br />
                    (If yes, please include when and what the charges were)
                    <textarea id='txtPleaseIncludeWhenAndWhat' name='txtPleaseIncludeWhenAndWhat' className='add-only'></textarea></p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Name of Juvenile Probation Officer (if applicable):</span></td>
                        <td className='w-375'><span className='eleHeader'>Phone number:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtNameOfJuvenile' name='txtNameOfJuvenile' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtPhoneNumber_2' name='txtPhoneNumber_2' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><h4>FINANCIAL/COMMUNITY RESOURCES </h4>(Please check all that apply)</p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <center><span className='eleHeader'>Resources <br />&nbsp;</span></center></td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>Used in the Past</span></center></td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>Currently Available</span></center></td>
                        <td className='w-200'>
                            <center><span className='eleHeader'>Currently Needed or Pursued</span></center></td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>N/A <br />&nbsp;</span></center></td>
                    </tr>
                </table>

                <table className='altRows'>
                    <tr>
                        <td className='w-250'>Friends/Family Support</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFriendsFamily_1' name='rbFriendsFamily' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFriendsFamily_2' name='rbFriendsFamily' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbFriendsFamily_3' name='rbFriendsFamily' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFriendsFamily_4' name='rbFriendsFamily' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Church</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbChurch_1' name='rbChurch' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbChurch_2' name='rbChurch' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbChurch_3' name='rbChurch' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbChurch_4' name='rbChurch' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>KidsNet</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbKidsNet_1' name='rbKidsNet' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbKidsNet_2' name='rbKidsNet' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbKidsNet_3' name='rbKidsNet' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbKidsNet_4' name='rbKidsNet' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>DFCS</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDfcs_1' name='rbDfcs' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDfcs_2' name='rbDfcs' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbDfcs_3' name='rbDfcs' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbDfcs_4' name='rbDfcs' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Wraparound Services</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbWraparoundServices_1' name='rbWraparoundServices' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbWraparoundServices_2' name='rbWraparoundServices' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbWraparoundServices_3' name='rbWraparoundServices' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbWraparoundServices_4' name='rbWraparoundServices' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Counseling</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCounseling_1' name='rbCounseling' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCounseling_2' name='rbCounseling' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbCounseling_3' name='rbCounseling' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCounseling_4' name='rbCounseling' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>DJJ/Juvenile Court</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbJuvenileCourt_1' name='rbJuvenileCourt' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbJuvenileCourt_2' name='rbJuvenileCourt' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbJuvenileCourt_3' name='rbJuvenileCourt' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbJuvenileCourt_4' name='rbJuvenileCourt' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>MH Services</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbMhServices_1' name='rbMhServices' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbMhServices_2' name='rbMhServices' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbMhServices_3' name='rbMhServices' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbMhServices_4' name='rbMhServices' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>SA Services</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSaServices_1' name='rbSaServices' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSaServices_2' name='rbSaServices' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbSaServices_3' name='rbSaServices' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSaServices_4' name='rbSaServices' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>School</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSchool_1' name='rbSchool' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSchool_2' name='rbSchool' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbSchool_3' name='rbSchool' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbSchool_4' name='rbSchool' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>IEP/Tutoring</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTutoring_1' name='rbTutoring' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTutoring_2' name='rbTutoring' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbTutoring_3' name='rbTutoring' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTutoring_4' name='rbTutoring' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Extracurricular/Community Activities</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbExtracurricular_1' name='rbExtracurricular' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbExtracurricular_2' name='rbExtracurricular' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbExtracurricular_3' name='rbExtracurricular' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbExtracurricular_4' name='rbExtracurricular' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>WIC</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbWic_1' name='rbWic' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbWic_2' name='rbWic' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbWic_3' name='rbWic' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbWic_4' name='rbWic' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>TANF / Food stamps</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFoodStamps_1' name='rbFoodStamps' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFoodStamps_2' name='rbFoodStamps' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbFoodStamps_3' name='rbFoodStamps' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFoodStamps_4' name='rbFoodStamps' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>CAPS</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCaps_1' name='rbCaps' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCaps_2' name='rbCaps' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbCaps_3' name='rbCaps' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbCaps_4' name='rbCaps' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Financial Aid - SSI/Medicaid</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFinancialMedicaid_1' name='rbFinancialMedicaid' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFinancialMedicaid_2' name='rbFinancialMedicaid' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbFinancialMedicaid_3' name='rbFinancialMedicaid' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFinancialMedicaid_4' name='rbFinancialMedicaid' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Child Support</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbChildSupport_1' name='rbChildSupport' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbChildSupport_2' name='rbChildSupport' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbChildSupport_3' name='rbChildSupport' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbChildSupport_4' name='rbChildSupport' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Private Insurance</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPrivateInsurance_1' name='rbPrivateInsurance' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPrivateInsurance_2' name='rbPrivateInsurance' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbPrivateInsurance_3' name='rbPrivateInsurance' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPrivateInsurance_4' name='rbPrivateInsurance' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>Other (Specify) </td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOtherSpecify_1' name='rbOtherSpecify' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOtherSpecify_2' name='rbOtherSpecify' className='add-only' value='2' /></center></td>
                        <td className='w-200'>
                            <center><input type='radio' id='rbOtherSpecify_3' name='rbOtherSpecify' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbOtherSpecify_4' name='rbOtherSpecify' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtOtherSpecify' name='txtOtherSpecify' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Does your child receive any financial compensation of any psychiatric or emotional disability? </span>
                    <span className='small'>(Please include pensions, SSI, SSDI, etc.)</span>
                    <textarea id='txtDoesYourChildReceiveAnyFinancial' name='txtDoesYourChildReceiveAnyFinancial' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>S (Strengths)</span>
                    <textarea id='txtStrengths' name='txtStrengths' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>N (Needs) </span>
                    <textarea id='txtNeeds' name='txtNeeds' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>A (Abilities)</span>
                    <textarea id='txtAbilities' name='txtAbilities' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>P (Preferences) (In clients own words!)  </span>
                    <textarea id='txtPerferencesInClients' name='txtPerferencesInClients' className='add-only'></textarea></p>

                <p className='w-750'><h4>RESPONSE TO INTERVIEW</h4>
                </p>

                <p className='w-750'><span className='eleHeader'>Parent/Guardian</span>
                    <textarea id='txtParentGuardian' name='txtParentGuardian' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Child/Adolescent </span>
                    <textarea id='txtChildAdolescent' name='txtChildAdolescent' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>DIAGNOSTIC IMPRESSIONS-ASSESSMENT SUMMARY</span>
                    <textarea id='txtDiagnosticImpressionsAssessmentSummary' name='txtDiagnosticImpressionsAssessmentSummary' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>DIAGNOSES (DSM5)</span>
                    <textarea id='txtDiagnoses' name='txtDiagnoses' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>INITIAL RECOMMENDATIONS FOR SERVICE PLAN:</span>
                    1.<input type='text' id='txtTimeBirth' name='txtTimeBirth' className='add-only w-700 custom-add-only' /><br />
                    2.<input type='text' id='txtTimeBirth' name='txtTimeBirth' className='add-only w-700 custom-add-only' /><br />
                    3.<input type='text' id='txtTimeBirth' name='txtTimeBirth' className='add-only w-700 custom-add-only' /><br />
                </p>

                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'>Assessor Name and Credential</td>
                        <td className='small w-300'>Signature</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'>Licensed Staff/Supervisor and Title</td>
                        <td className='small w-300'>Signature</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                </table>










            </div>
        </form >

    )
}  
